// global.img_url = 'http://greatpharma.org/pos_server/public';
// Use dev mode URL if available, otherwise fall back to production URL or default
global.img_url = process.env.REACT_APP_IMAGE_URL || 
                 process.env.REACT_APP_DEV_MODE_IMAGE_URL || 
                 process.env.REACT_APP_PRO_MODE_IMAGE_URL || 
                 'http://127.0.0.1:8001/public';
